export const getCountryVatCode = (code: string) => {
  const countryToVatCodeMap = {
    GR: 'EL'
  };

  return countryToVatCodeMap[code] || code;
};
